import { Grid, Paper } from '@mui/material'
import React from 'react'
import { BackButton } from './BackButton'
import { SubmitButton } from './SubmitButton'
import { PrintFormButton } from './PrintFormButton'

export interface Props {
  title?: React.ReactNode
  PaperComponent?: React.ComponentType<React.PropsWithChildren<{}>>
  backButtonProps?: Partial<React.ComponentProps<typeof BackButton>>
  printButtonProps?: Partial<React.ComponentProps<typeof PrintFormButton>>
  submitButtonProps?: Partial<React.ComponentProps<typeof SubmitButton>>
}

/**
 * BasicFormLayout provides some basic structure. it wraps your content with a back/submit button and a paper
 *  it should only be used inside a Form component (or other formix wrapper)
 */
export const BasicFormLayout: React.FC<Props> = ({
  children,
  title,
  backButtonProps,
  printButtonProps,
  submitButtonProps,
  PaperComponent = DefaultPaperComponent
}) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container justifyContent='space-between' spacing={1} sx={{ pt: '8px', pb: '16px' }}>
          <Grid item sx={{ fontWeight: 600, fontSize: '28px', alignSelf: 'center' }} data-testid='form-title'>
            {title}
          </Grid>
          <Grid item>
            <Grid container justifyContent='flex-end' spacing={1}>
              <Grid item>
                <PrintFormButton {...printButtonProps} />
              </Grid>
              <Grid item>
                <BackButton {...backButtonProps} />
              </Grid>
              <Grid item>
                <SubmitButton {...submitButtonProps} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PaperComponent>{children}</PaperComponent>
      </Grid>
    </Grid>
  )
}

export default BasicFormLayout

export const DefaultPaperComponent: React.FC<{}> = ({ children }) => {
  return <Paper sx={{ p: 2 }}>{children}</Paper>
}

export const NoPaperComponent: React.FC<{}> = ({ children }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
